/* eslint-disable */
export default {
  pages: {
    key: "title",
    data: [
      {title: 'Dashboard',   url: '/', icon: 'HomeIcon', is_bookmarked: true},
      {title: 'Page 2', url: '/page2', icon: 'FileIcon', is_bookmarked: false},
      {title: 'Page 2', url: '/page2', icon: 'FileIcon', is_bookmarked: false},
      {title: 'Page 2', url: '/page2', icon: 'FileIcon', is_bookmarked: false},
      {title: 'Page 2', url: '/page2', icon: 'FileIcon', is_bookmarked: false},
    ]
  }
}
/* eslint-enable */
